<template>
  <b-modal
    id="modal-addProjectToPackage"
    title="Dodaj nov projekt na paket"
    size="lg"
    body-bg-variant="light"
    header-bg-variant="secondary"
    header-text-variant="dark"
    ok-disabled
    centered
  >
    <b-row class="mt-5 justify-content-center">
      <b-col md="10">
        <b-form class="newProject">
          <b-form-row>
            <b-col cols="12">
              <b-form-group description="Izberi naročnika">
                <multiselect
                  required
                  v-model="form.projects"
                  :options="projects"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Izberi"
                  label="title"
                  track-by="id"
                  :preselect-first="false"
                  :allow-empty="false"
                >
                  <template slot="option" slot-scope="props"
                    ><strong>{{ props.option.title }}</strong>
                    <small class="ml-2">
                      {{ props.option.client }}
                    </small>
                  </template>
                  <template
                    slot="selection"
                    slot-scope="{ values, search, isOpen }"
                  >
                    <span
                      class="multiselect__single"
                      v-if="values.length && !isOpen"
                      >{{ values.length }} izbranih</span
                    >
                  </template>
                </multiselect>
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-form></b-col
      ></b-row
    >
    <template v-slot:modal-footer>
      <b-button
        @click="$bvModal.hide('modal-addProjectToPackage')"
        class="btn btn-muted btn-md"
      >
        Prekliči
      </b-button>
      <b-button
        type="submit"
        @click="onSubmit"
        class="btn btn-dark btn-md"
        :disabled="isSending"
      >
        Dodaj projekte v paket
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import Multiselect from "vue-multiselect";

Vue.component("multiselect", Multiselect);

export default {
  components: {
    Multiselect,
  },
  props: ["projects"],
  data() {
    return {
      isSending: false,
      form: {
        projects: [],
      },
    };
  },
  mounted: function() {
    this.fetchCompanies();
  },
  methods: {
    customLabel({ title, client }) {
      return `${title} ${client}`;
    },
    fetchCompanies: function() {
      this.$store
        .dispatch("api/fetchClients")
        .then(() => {
          this.companies = this.$store.getters["api/getClients"];
        })
        .catch((err) => console.log(err));
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.isSending = true;

      let packageId = this.$route.params.packageId;
      let submitData = this.form;

      return new Promise((resolve, reject) => {
        axios({
          url: `${this.$store.state.login.url}/api/dashboard/packages/${packageId}/projects/add`,
          headers: {
            Authorization: `Bearer ${this.$store.state.login.token}`,
            "Content-Type": "application/json",
          },
          data: JSON.stringify(submitData),
          method: "POST",
        })
          .then((response) => {
            // cleanup form
            this.isSending = false;
            this.$bvModal.hide("modal-addProjectToPackage");
            this.$router.go();
            this.$bvToast.toast(response.data.message, {
              title: "Success",
              autoHideDelay: 5000,
            });
            resolve(response);
          })
          .catch((err) => {
            this.isSending = false;
            this.$bvToast.toast(err.message, {
              title: "Something went wrong ... ",
              autoHideDelay: 5000,
            });
            reject(err);
          });
      });
    },
  },
};
</script>
